import React from 'react';
import './Card.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  padding?: 'none' | 'small' | 'medium' | 'large';
  variant?: 'default' | 'simple' | 'large' | 'flat';
}

export const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  onClick,
  padding = 'medium',
  variant = 'default'
}) => {
  // Определяем класс в зависимости от варианта (flat = Easypay как mobile)
  const neumorphismClass = variant === 'flat'
    ? 'card--flat'
    : variant === 'large' 
    ? 'neo-raised-lg' 
    : variant === 'simple' 
    ? 'neo-raised-simple' 
    : 'neo-raised';
  
  return (
    <div 
      className={`card card--padding-${padding} ${neumorphismClass} ${onClick ? 'card--clickable' : ''} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
};

